import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { CashDrawerChangeDTOBase } from "./CashDrawerChangeDTOBase";
import type { CashDrawerChangeType } from "./CashDrawerChangeType";
import type { CashDrawerStaff } from "./CashDrawerStaff";
import type { TrackedModernBase } from "./TrackedModernBase";

export class CashDrawerChangeStaff implements CashDrawerChangeDTOBase, TrackedModernBase {
  constructor(public readonly assignId: number, public readonly changeType: CashDrawerChangeType, public readonly amountCents: number, public readonly amountTendered: number | null, public readonly cashDrawer: CashDrawerStaff | null, public readonly createdOn: Date | null, public readonly createdBy: string | null, public readonly updatedOn: Date | null, public readonly updatedBy: string | null) {
    this.cbiServiceContext = null;
    this.cashDrawerLoaded = this.cashDrawer != null;
    this.cashDrawerCached = this.cashDrawer;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private cashDrawerLoaded: boolean;
  private cashDrawerCached: CashDrawerStaff | null;
  async cashDrawerLazy(): Promise<CashDrawerStaff | null> {
    if (!this.cashDrawerLoaded) {
      this.cashDrawerCached = await this.cbiServiceContext!.cashDrawerService().getCashDrawerChangeStaffCashDrawer(this.assignId);
      this.cashDrawerLoaded = true;
    }
    return this.cashDrawerCached;
  }
}
